import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Importa la configuración del router

// ✅ 1. Se AGREGA ESTAS LÍNEAS AQUÍ (antes de montar la app)
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

// ✅ 2. Se CREA LA INSTANCIA DE PINIA Y APLICA EL PLUGIN
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

import "bootstrap/dist/css/bootstrap.min.css"; // Importa Bootstrap CSS
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// CSS > HOVER_EFFECTS > NAVBAR Animaciones de la barra de navegación
import "@/assets/css/hover_effects/navbar/navbar-hover5.css"; //5 CSS navbar
//CSS> HOVER_EFFECTS > DROPDOWN Animaciones de los menus desplegables
import "@/assets/css/hover_effects/dropdown/navbar-dropdown.css"; //1 CSS dropdown
import "./assets/css/typography.css"; // Importa las fuentes globales
import "@/assets/css/hover_effects/images-effects/card-hover.css"; // CSS card hover
import "@/assets/css/scroll_effects/scroll_reveal.css"; // CSS scroll reveal

// ✅ 3. Se agrega  pinia a la instancia de Vue
createApp(App)
  .use(pinia) // << AQUI
  .use(router) // Usa el router en la instancia de Vue
  .mount("#app");
